import {Injectable} from '@angular/core';
import {AuthService, BaseService} from '@hassel-it/angular-common';
import {HttpClient} from '@angular/common/http';

@Injectable()
export class BranchesService extends BaseService {

    public branches = {
        cla: 'Centrallager',
        hoe: 'Aarhus',
        rin: 'Ringkøbing',
        ulf: 'Ulfborg',
        var: 'Varde',
        vib: 'Viborg',
        vid: 'Videbæk'
    };

    public branchesDetails = [
        {
            key: 'cla',
            name: 'Centrallager'
        },
        {
            key: 'hoe',
            name: 'Aarhus'
        },
        {
            key: 'rin',
            name: 'Ringkøbing'
        },
        {
            key: 'ulf',
            name: 'Ulfborg',
        }, {
            key: 'var',
            name: 'Varde',
        }, {
            key: 'vib',
            name: 'Viborg',
        }, {
            key: 'vid',
            name: 'Videbæk'
        },
    ];

    constructor(public http: HttpClient, public authService: AuthService) {
        super(http, authService);
    }
}
